import React from 'react';
import PageHeader from '../ui/PageHeader';
import type { SettingsHubHelpItem } from '../../modules/configuration-settings/models';

export interface ModuleHelpHeaderProps {
  title?: string;
  description?: React.ReactNode;
  helpItems?: SettingsHubHelpItem[];
  className?: string;
}

const ModuleHelpHeader: React.FC<ModuleHelpHeaderProps> = ({
  title,
  description,
  helpItems,
  className,
}) => {
  if (!title && !description && !helpItems?.length) return null;

  return (
    <PageHeader
      title={title ?? ''}
      description={description}
      helpItems={helpItems}
      className={className}
    />
  );
};

export default ModuleHelpHeader;
